export enum CacheTime {
  MAIN_PAGE = 15 * (60 * 1000), // 15 min
  WIZARD_PAGE = 10 * (60 * 1000), // 10 min
  THIRTY_SECONDS = 30 * 1000 // 30 sec
}
